module.exports = __webpack_public_path__ + "img/img22.ec930bc3.png";